import React from 'react';

function Dropdown({ size, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <rect x="0.65" y="7.65" width="22.7" height="8.7" rx="1.35" />
      <path d="M 17 11 19 13 21 11" strokeLinejoin="miter" />
    </svg>
  );
}

export default Dropdown;
